import PropTypes from "prop-types"

import { cn } from "styles/utils"

export const Section = ({ className = "", hasBg, ...props }) => (
  <div
    className={cn(
      "tablet:px-0 mb-32 px-16",
      hasBg && "bg-grey-4 py-32",
      className
    )}
    {...props}
  />
)
Section.propTypes = {
  className: PropTypes.string,
  hasBg: PropTypes.bool,
}
export default Section
